import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de as deLocale } from 'date-fns/locale/de';
import { observer } from 'mobx-react';
import { theme } from './components/utils/Theme';
import { AppRouter } from './router/AppRouter';
import { authStore } from './stores/AuthStore';
const BUILD_DATE = __BUILD_DATE__;

const App: React.FunctionComponent = observer(() => {
  console.log('Build Date: ' + BUILD_DATE + ' (GMT)');
  if (!authStore.isRehydrated) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
        <AppRouter />
      </LocalizationProvider>
    </ThemeProvider>
  );
});

export default App;
